import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as myselfActions from 'actions/myself';
import * as contactActions from 'actions/contacts';
import * as profileActions from 'actions/profile';

import Loading from 'components/Loading';
import JournalEntries from 'components/JournalEntries';
import MediaMdUp from 'components/Responsive/MediaMdUp';
import MediaSmDown from 'components/Responsive/MediaSmDown';
import MediaSmUp from 'components/Responsive/MediaSmUp';
import MediaXsDown from 'components/Responsive/MediaXsDown';
import TheySay from 'components/TheySay';

import AddToContacts from './components/AddToContacts';
import Hero from './components/Hero';
import MantelAndScrap from './components/MantelAndScrap';
import ProfileCard from './components/ProfileCard';
import ProfileInventoryGroups from './components/ProfileInventoryGroups';

import ProfileContext from './ProfileContext';

class ProfileContainer extends Component {
  componentDidMount = () => {
    const { loggedIn, fetchContacts } = this.props;
    this.fetchProfile();
    if (loggedIn) {
      fetchContacts();
    }
  }

  /**
   * Fetch this user's profile with permalink ID
   */
  fetchProfile = async () => {
    const { fetchProfile, match } = this.props;
    const { profileName } = match.params;
    await fetchProfile(profileName);
  }

  /**
   * Render
   * @return {Object}
   */
  render() {
    const {
      currentArea,
      profileCharacter,
      description,
      lookingAtOwnProfile,
    } = this.props;

    if (!profileCharacter) {
      return (
        <div>
          <Hero currentArea={currentArea} />
          <Loading spinner />
        </div>
      );
    }

    return (
      <ProfileContext.Provider
        value={{
          profileCharacter,
          editable: lookingAtOwnProfile,
        }}
      >
        <div>
          <Hero
            currentArea={currentArea}
            description={description}
          />

          <div className="profile">
            <div className="profile__left">
              <div className="profile__card-and-switcher">
                <div className="profile__card-and-header">
                  <h2 className="heading heading--2 profile__card-header">Cameo</h2>
                  <ProfileCard
                    profileUp
                  />
                </div>
                <div className="profile__card-and-header">
                  <h2 className="heading heading--2 profile__card-header">Lodgings</h2>
                  <ProfileCard />
                </div>
                <AddToContacts />
              </div>
              <div className="profile__inventory-groups">
                <ProfileInventoryGroups />
                <MediaSmUp>
                  <TheySay
                    profileCharacter={profileCharacter}
                    editable={lookingAtOwnProfile}
                  />
                </MediaSmUp>
                <MediaSmDown>
                  <MantelAndScrap />
                </MediaSmDown>
              </div>
              <MediaXsDown>
                <TheySay
                  profileCharacter={profileCharacter}
                  editable={lookingAtOwnProfile}
                />
              </MediaXsDown>
            </div>

            <div className="profile__body">
              <MediaMdUp>
                <MantelAndScrap />
              </MediaMdUp>
              <JournalEntries />
            </div>
          </div>
        </div>
      </ProfileContext.Provider>
    );
  }
}

ProfileContainer.displayName = 'ProfileContainer';

ProfileContainer.propTypes = {
  currentArea: PropTypes.shape({}),
  description: PropTypes.string,
  fetchContacts: PropTypes.func.isRequired,
  fetchProfile: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  lookingAtOwnProfile: PropTypes.bool.isRequired,
  profileCharacter: PropTypes.shape({}),
};

ProfileContainer.defaultProps = {
  currentArea: null,
  description: null,
  profileCharacter: null,
};

const mapStateToProps = ({
  contacts: { contacts },
  profile: {
    currentArea,
    description,
    lookingAtOwnProfile,
    profileCharacter,
  },
  user: { loggedIn },
  myself: { qualities },
}) => ({
  currentArea,
  description,
  lookingAtOwnProfile,
  profileCharacter,
  contacts,
  loggedIn,
  qualities,
});

const mapDispatchToProps = {
  ...myselfActions,
  ...contactActions,
  ...profileActions,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileContainer));